import { DetailedHTMLProps, ImgHTMLAttributes, useState } from "react";

export default function ImageWithFallback({
  srcset,
  ...props
}: {
  srcset: (string | null)[];
} & DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
  const [index, setIndex] = useState(0);

  function onError() {
    setIndex((previousIndex) => previousIndex + 1);
  }

  return (
    <img
      {...props}
      loading="lazy"
      src={srcset.filter(Boolean)[index] ?? "/icon.png"}
      onError={onError}
    />
  );
}
